// extracted by mini-css-extract-plugin
module.exports = {"ulStyle":"style_ulStyle___T4PU","liText":"style_liText__EBwvB","ulCol":"style_ulCol__RnrYa","rowWrapper":"style_rowWrapper__mOi6s","imgColWrapper":"style_imgColWrapper__alJ4N"};